module.exports = __webpack_public_path__ + "img/product11.23a3fa07.png";